'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import ScopedFeatureTooltip from 'FileManagerCore/components/permissions/ScopedFeatureTooltip';
import { ObjectCategory } from 'FileManagerCore/Constants';
import { isFile } from 'FileManagerCore/utils/FoldersAndFiles';
import * as ModalTypes from '../enums/ModalTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default class RenameButton extends Component {
  constructor(...args) {
    super(...args);
    this.handleClick = () => {
      const {
        object
      } = this.props;
      const objectCategory = isFile(object) ? ObjectCategory.FILE : ObjectCategory.FOLDER;
      this.props.openModal(ModalTypes.RENAME, {
        objectCategory,
        objectId: object.get('id')
      });
    };
  }
  render() {
    const {
      object,
      isReadOnly,
      size
    } = this.props;
    return /*#__PURE__*/_jsx(ScopedFeatureTooltip, {
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": isFile(object) ? 'rename-file-button' : 'rename-folder-button',
        size: size,
        use: "tertiary-light",
        disabled: isReadOnly,
        onClick: this.handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "FileManagerDashboard.actions.rename"
        })
      })
    });
  }
}
RenameButton.propTypes = {
  object: PropTypes.instanceOf(Immutable.Map).isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  size: UIButton.propTypes.size
};
RenameButton.defaultProps = {
  size: 'small'
};